module.exports = ".app-container{overflow-y:hidden}.router-outlet-container{overflow-y:auto}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main